(function () {
  var instances = {};

  function initCarousel(container) {
    if (!window.Swiper || !container) return;

    var sliderEl = container.querySelector('.tsc__slider');
    if (!sliderEl) return;

    var sectionId = container.getAttribute('id');
    var autoplayEnabled = container.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(container.getAttribute('data-autoplay-speed'), 10) || 5000;

    var config = {
      effect: 'creative',
      creativeEffect: {
        limitProgress: 3,
        shadowPerProgress: true,
        perspective: true,
        prev: {
          translate: ['-105%', '4%', -70],
          rotate: [0, 0, -3]
        },
        next: {
          translate: ['105%', '4%', -70],
          rotate: [0, 0, 3]
        }
      },
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: true,
      grabCursor: true,
      navigation: {
        prevEl: container.querySelector('.tsc__btn-prev'),
        nextEl: container.querySelector('.tsc__btn-next')
      },
      pagination: {
        el: container.querySelector('.tsc__pagination'),
        type: 'progressbar'
      }
    };

    if (autoplayEnabled) {
      config.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false
      };
    }

    instances[sectionId] = new window.Swiper(sliderEl, config);
  }

  function destroyCarousel(sectionId) {
    if (instances[sectionId]) {
      instances[sectionId].destroy(true, true);
      delete instances[sectionId];
    }
  }

  function initAll() {
    document.querySelectorAll('[data-testimonials-carousel]').forEach(initCarousel);
  }

  if (window.Swiper) {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('[data-testimonials-carousel]');
    if (container) initCarousel(container);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target.querySelector('[data-testimonials-carousel]');
    if (container) destroyCarousel(container.getAttribute('id'));
  });

  document.addEventListener('shopify:block:select', function (event) {
    var container = event.target.closest('[data-testimonials-carousel]');
    if (!container) return;
    var sectionId = container.getAttribute('id');
    if (instances[sectionId]) {
      var slideIndex = Array.prototype.indexOf.call(
        container.querySelectorAll('.tsc__slide'),
        event.target
      );
      if (slideIndex > -1) {
        instances[sectionId].slideToLoop(slideIndex);
        instances[sectionId].autoplay && instances[sectionId].autoplay.stop();
      }
    }
  });
})();
